<!--
 * @Description: 抵押申请结果
 * @Author: 胡博君
 * @Date: 2019-12-11 16:44:17
 * @LastEditors: 胡博君
 * @LastEditTime: 2019-12-18 17:12:47
 -->

<template>
  <div class="loan-mortgage-result">
    <div class="header">
      <p>代理人将协助您办理业务，请在办理完成后，点击下方确认按钮。</p>
      <div
        @click="makeSure"
        class="header__btn">确认办理完成</div>
    </div>
    <ul class="list">
      <li class="list__item">
        <div class="list__item-header">
          <div class="list__item-car">
            <span>车牌号</span>
          </div>
        </div>
        <ul class="list__item-des">
          <li>
            <span>借款申请日期</span>
            <span>2019.11.12</span>
          </li>
          <li>
            <span>借款申请日期</span>
            <span>2019.11.12</span>
          </li>
          <li>
            <span>借款申请日期</span>
            <span>2019.11.12</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      handleResult: ''
    }
  },
  mounted() {
    let carId = this.$route.query.carId || '';
    this.handleResult = this.$route.query.handleResult || '0';
    this.getMsg(carId);
  },
  methods: {
    getMsg(cardId) {
      this.axios({
        url: '/pledge/'+carId+'/detail',
        method: 'post'
      }).then((res) => {
      });
    },
    makeSure() {
      MessageBox({
        title: '',
        message: '确定你的抵押业务已经办理完成了吗？',
        showCancelButton: true,
        confirmButtonClass: 'header__sure'
      }).then(({ value, action }) => {

      });
    }
  }
}
</script>
<style lang="scss">
.header__sure {
  color: #EC702F;
}
.loan-mortgage-result {
  color: #999;
  font-size: 28px;
  .header {
    padding: 54px;
    background: #fff;
    p {
      margin-bottom: 43px;
    }
    &__btn {
      margin: 0 auto;
      text-align: center;
      width: 280px;
      height: 72px;
      line-height: 72px;
      background: #008DF6;
      border-radius: 8px;
      color: #fff;
    }
  }
  .list {
    &__item {
      padding-left: 30px;
      &-header {
        padding-right: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 90px;
        font-size: 26px;
        border-bottom: 1Px solid #EEEEEE;
      }
      &-car {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
        }
      }
      &-des {
        padding: 30px 30px 10px 0;
        li {
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          span:nth-child(2) {
            color: #333;
          }
        }
      }
    }
  }
}
</style>




